<template>

  <div id="wrap" :style="{ height: screenHeight + 'px' }" class="wrap_div">
  <v-touch @swipeup="swiperup" @swipedown="swipedown">

    <div id="main" :style="{ top: nowTop + 'px' }" class="main_div">

      <div id="page1" class="page">
        <img src="../../../static/img/Background.jpg" class="bannerimg" />
        <div class="slide">
          <img src="../../../static/img/27.png" class="jiantou" />
          <!-- <div><span v-if="language == 'zh'">向上滑动</span><span v-else>Wipe up</span></div> -->
        </div>
        <div class="slide-bottom">
          <img src="../../../static/img/28.png" class="banner-bottomimg" />
        </div>
      </div>
      <div id="page2" class="page" >
        <div class="introduce" id="pageUl" type="circle" :class="curIndex!=1?'showUl':'hideUl'">
          <div class="container">
            <div class="pagenav">
              <div class="nav-item" v-for="(item,i) in menu" :key="i" :class="curIndex == (i+2) ?'active':''"  @click="navTo(i+2,$event)">
                {{language == 'zh'?item.nm:item.en}}<img v-if="curIndex == (i+2)" src="../../../static/img/30.png" class="jiantou-right" />
              </div>
            </div>
          </div>
        </div>
        <div class="mainbox margin-left">
          <el-row :gutter="50" class="el-row-top">
            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" id="about" class="about">
              <div class="aboutbox">
                <div class="title">
                  <span class="bigtitle"
                    v-html="language == 'zh' ? companyInfo.title : companyInfo.titleEn"
                  ></span>
                  <!-- <div class="bigtitle"><span v-if="language == 'zh'">海德贝思液压技术（浙江）有限公司</span><span v-else>HydraBase Tech（Zhejiang）Co., Ltd</span></div> -->
                  <div class="smalltitle">
                    <span :class="language == 'zh'?'line-height-zh':'line-height-en'"
                    v-html="language == 'zh' ? companyInfo.content : companyInfo.contentEn"
                  ></span>
                    <!-- <span v-if="language == 'zh'" class="line-height-zh">海德贝思液压技术（浙江）有限公司，坐落于制造业之乡：宁波，拥有占地面积10,000平方米的制造基地，是一家专注于研发生产方向控制阀、压力控制阀、电磁换向阀、流量控制阀等高性能螺纹插装阀及相关元件的创新型企业。产品可广泛应用于工程机械、农业机械、起重机械行走机械液压系统，工业生产制造设备液压系统，以及石油化工、冶金矿山、船舶工业用液压系统等。</span>
                    <span v-else class="line-height-en">Located in Ningbo with 10,000m2 manufacturing base, HydraBase Tech（Zhejiang）Co., Ltd is an innovative enterprise at a high starting point, focusing on high performance screw-in hydraulic cartridge valves and other hydraulic devices. Our products portfolio contains directional valves, pressure control valves, solenoid valves, hand pumps, etc. Our products can be widely applied to the hydraulic systems in the filed of engineering construction, mining, petrochemical , shipping, and thermal & wind power generation, etc.</span>
                    <br /><br />
                    <span v-if="language == 'zh'" class="line-height-zh"> 公司每年研发投入占营业收入15%以上，研发团队成员具有丰富的产品研发经验和行业技术背景，并配备独立的试验、试制场地和专业测试设备。公司现拥有一线品牌圆柱度测量仪，CNC三坐标测量机，CNC加工中心，CNC车铣复合中心，内圆磨床，外圆磨床，无心磨床等高精设备仪器保障产品生产工艺和质量，并以ISO9001:2015标准严格控制生产工艺，制造精度对标国际一流水平。海德贝思以产品质量和技术创新为根本，不断提升中国制造的品牌力，为客户提供优质的产品和服务。</span>
                    <span v-else class="line-height-en">As a technology and innovation driven enterprise, our annual R&D investment account for over 15% of operation revenue. We also have a R&D center and recruit engineers and specialists with solid background knowledge and sufficient working experience. For process and quality control, we have invested first-class operating machines such as cylindricity instrument, CMM, CNC machining center, turn-milling machining center, internal & external grinding machine, centerless grinding machine and are strictly following the ISO9001:2015 standard. Most of our products’ precision align with world-class standard.</span>
                   -->
                  </div>
                </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14" id="about-right">
              <img src="../../../static/img/CompanyPhoto.jpg" ref="CompanyPhoto" class="CompanyPhoto" />
            </el-col>
          </el-row>
          <el-row :gutter="50" class="bottom-card" type="flex">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="item" @mouseenter="showBottom1=true" @mouseleave="showBottom1=false">
                  <div class="top">
                    <img :src="showBottom1?'../../../static/img/资源 35.png':'../../../static/img/资源 33.png'"/>
                  </div>
                  <div class="bottom">
                      <div class="bigtitle"><span v-if="language == 'zh'">我们的愿景</span><span v-else>Our Vison</span></div>
                      <span v-if="language == 'zh'">成为国际一流，</br>行业领先品牌</span>
                      <span v-else>To be an industry-leading brand in the worldwide.</span>
                  </div>
              </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <div class="item" @mouseenter="showBottom2=true" @mouseleave="showBottom2=false">
                  <div class="top">
                    <img :src="showBottom2?'../../../static/img/资源 34.png':'../../../static/img/资源 32.png'"/>
                  </div>
                  <div class="bottom">
                      <div class="bigtitle"><span v-if="language == 'zh'">我们的使命</span><span v-else>Our Mission</span></div>
                      <span v-if="language == 'zh'">携手员工，客户与合作伙伴，</br>共同推进行业发展，创造社会价值</span>
                      <span v-else>To create value to industry and society by collaborating with employee customers and partners. </span>
                  </div>
              </div>
            </el-col>
          </el-row>

        </div>
      </div>
      <div id="page3" class="page">
      <div class="mainbox">
        <div class="application" id="application">
          <div class="biaoti"><span v-if="language == 'zh'">"TRUE"经营理念</span><span v-else>"TRUE" Core Value</span></div>
          <div class="container">
              <div class="or-container">
                <div class="box" :class="eleindex ==i?'eleactive':''" v-for="(ele,i) in piclist" :key="i" @mouseenter="enter(i)" @mouseleave="out(i)">
                  <img :src="eleindex == i?ele.img:ele.bg">
                  <div class="top">{{language == 'zh'?ele.text:ele.text1}}</div>
                  <div class="bottom" v-if="language == 'zh'">{{ele.text1}}</div>
                  <div class="account" v-html="language == 'zh'?ele.account:ele.enaccount"></div>
                </div>
              </div>
          </div>
        </div>
      </div>
      </div>
      <div id="page4" class="page">
        <div class="mainbox">
          <div class="huanjing" id="rongyu">
            <div class="biaoti"><span v-if="language == 'zh'">资质荣誉</span><span v-else>Qualifications</span></div>
            <div class="container dbanner">
              <mySwiper  ref="mySwiper" :language="language">
            </mySwiper>
                <!-- <el-carousel @change="changetext" ref="homeban" :autoplay="true" arrow="never" indicator-position="none" type="card" height="50vh!important">
                  <el-carousel-item v-for="(item,i) in zzry" :key="i">
                    <img :src="item.img" class="cardimg" />
                  </el-carousel-item>
                </el-carousel>
                <img
                  src="../../../static/img/资源45.png"
                  class="bannerleft"
                  @click="prev()"
                />
                <img
                  src="../../../static/img/资源452.png"
                  class="bannerright"
                  @click="next()"
                /> -->
          <!-- <div class="middle_banner">
          <div class="swiper-button-prev swiper-button-prev1"></div>
          <div class="swiper-container mySwiper mySwiper1">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in zzry"
                :key="index"
              >
                <img class="book1_img" :src="item.img" />
              </div>
            </div>
          </div>
          <div class="swiper-button-next swiper-button-next1"></div>
        </div> -->
                <div class="bannertext">{{bannertext}}</div>
            </div>
          </div>
        </div>
      </div>
      <div id="page5" class="page">
        <div class="mainbox" style="height:1080px">
          <div class="huanjing" id="huanjing">
            <div class="biaoti"><span v-if="language == 'zh'">设备环境</span><span v-else>Plant&Facility</span></div>
            <swiperBox class="realData" ref="swiperBox" :language="language">
            </swiperBox>
          </div>
        </div>
          <Foot class="foot-div" :language="language" :menu="footmenu"></Foot>
      </div>
    </div>

  </v-touch>
  </div>

</template>

<script>
import Foot from "../../components/Foot";
import swiperBox from "../../components/SwiperBox";
import mySwiper from "./MySwiper.vue";
export default {
  components: {
    Foot,
    swiperBox,
    mySwiper,
  },
  props: {
    language: {
      type: String,
      default: "",
    },
  },
  name: "Home",
  data() {
    return {
      companyInfo: {},
      footmenu: [],
      screenWeight: 0, // 屏幕宽度
      screenHeight: 0, // 屏幕高度
      index: 1, // 用于判断翻页
      curIndex: 1, // 当前页的index
      startTime: 0, // 翻屏起始时间
      endTime: 0, // 上一次翻屏结束时间
      nowTop: 0, // 翻屏后top的位置
      pageNum: 0, // 一共有多少页
      main: Object,
      obj: Object,
      piclist: [
        {
          account: "专注研发与技术创新，面向未来和挑战",
          enaccount:
            "Focusing on technology and innovation, embracing the challenge",
          text: "科技创新",
          text1: "Tech. & Innovation",
          bg: require("../../../static/img/38.png"),
          img: "../../../static/img/42.png",
        },
        {
          account: "严格把控生产细节，绝不向质量妥协",
          enaccount:
            "Strictly controlling the quality, <br/>producing reliable products",
          text: "品质可靠",
          text1: "Reliability",
          bg: require("../../../static/img/39.png"),
          img: "../../../static/img/43.png",
        },
        {
          account: "坚守诚信理念和社会责任使命，联合客户实现价值",
          text: "统一价值",
          enaccount:
            "Insisting on integrity and social responsibility, collaborating with customers for value creation",
          text1: "United Value",
          bg: require("../../../static/img/37.png"),
          img: "../../../static/img/41.png",
        },
        {
          account: "重视人才培养和员工价值赋能，以团队为公司发展基石",
          enaccount: "Empowering employees, <br/>appreciating teamwork",
          text: "团队共创",
          text1: "Empowerment",
          bg: require("../../../static/img/36.png"),
          img: "../../../static/img/40.png",
        },
      ],
      eleindex: 0,
      bannertext: "",
      rongyuList: [
        {
          img: "../../../static/img/Certificate1-Left.png",
          text: "质量管理体系认证",
        },
        {
          img: "../../../static/img/Certificate2-Mid.png",
          text: "质量管理体系认证1",
        },
        {
          img: "../../../static/img/Certificate3-Right.png",
          text: "质量管理体系认证2",
        },
        {
          img: "../../../static/img/Certificate3-Right.png",
          text: "质量管理体系认证3",
        },
      ],
      menu: [
        {
          nm: "关于我们",
          en: "About us",
        },
        {
          nm: "经营理念",
          en: "Core Value",
        },
        {
          nm: "资质荣誉",
          en: "Qualifications",
        },
        {
          nm: "公司环境",
          en: "Plant&Facility",
        },
      ],
      introduceshow: false,
      showBottom1: false,
      showBottom2: false,
      zzry: [],
      slides: [],
    };
  },
  watch: {
    //监听路由变化
    $route(to, from) {
      console.log(to);
      if (to.fullPath.indexOf("Aboutus") >= 0) {
        console.log("hideHeader");
        this.init();
        this.$parent.hideHeader = this.curIndex == 1;
      } else {
        this.$parent.hideHeader = true;
      }
    },
    //监听轮播数据变化后再创建实例
    zzry() {
      this.$nextTick(() => {
        new Swiper(".mySwiper1", {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          autoplay: true,
          navigation: {
            nextEl: ".swiper-button-next1",
            prevEl: ".swiper-button-prev1",
          },
        });
      });
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    swiperup() {
      console.log("swiperup==" + this.index);
      if (this.index < 5) {
        this.toPage((this.index += 1));
      }
    },
    swipedown() {
      console.log("swipedown==" + this.index);
      if (this.index > 0) {
        this.toPage((this.index -= 1));
      }
    },
    prev() {
      this.$refs.homeban.prev();
    },
    next() {
      this.$refs.homeban.next();
    },
    init() {
      // this.getInfo();
      this.getCompanyInfo();
      this.getInfoMenu();
      this.$emit("changefoot", false);

      this.$parent.hideHeader = true;
      this.screenWeight = document.documentElement.clientWidth;
      this.screenHeight = document.documentElement.clientHeight;
      this.main = document.getElementById("main");
      this.obj = document.getElementsByTagName("div");
      for (let i = 0; i < this.obj.length; i++) {
        if (this.obj[i].className == "page") {
          this.obj[i].style.height = this.screenHeight + "px";
          if (i == 5) {
            this.obj[i].style.height = "1080px";
          }
        }
      }
      this.pageNum = document.querySelectorAll(".page").length;

      // 浏览器兼容
      if (navigator.userAgent.toLowerCase().indexOf("firefox") != -1) {
        document.addEventListener("DOMMouseScroll", this.scrollFun, false);
      } else if (document.addEventListener) {
        document.addEventListener("mousewheel", this.scrollFun, false);
      } else if (document.attachEvent) {
        document.attachEvent("onmousewheel", this.scrollFun);
      } else {
        document.onmousewheel = this.scrollFun;
      }
      if (this.GetQueryString("type")) {
        console.log("GetQueryString==" + this.GetQueryString("type"));
        this.navTo(this.GetQueryString("type"));
      }
      window.addEventListener("resize", () => {
        if (this.GetQueryString("type")) {
          console.log("GetQueryString==" + this.GetQueryString("type"));
          this.navTo(this.GetQueryString("type"));
        }
      });
    },
    navTo(a) {
      this.index = a;
      this.toPage(a);
      this.active = a;
    },
    scrollFun(event) {
      if (window.location.href.indexOf("/Aboutus") >= 0) {
        this.startTime = new Date().getTime();
        // mousewheel事件中的 “event.wheelDelta” 属性值：返回的如果是正值说明滚轮是向上滚动
        // DOMMouseScroll事件中的 “event.detail” 属性值：返回的如果是负值说明滚轮是向上滚动
        let delta = event.detail || -event.wheelDelta;
        // 如果当前滚动开始时间和上次滚动结束时间的差值小于1.5s，则不执行翻页动作，这样做是为了实现类似节流的效果
        if (this.startTime - this.endTime > 200) {
          console.log("curIndex==" + this.curIndex);
          if (
            delta > 0 &&
            parseInt(this.main.offsetTop) >=
              -(this.screenHeight * (this.pageNum - 2))
          ) {
            // 向下滚动
            this.index++;
            this.toPage(this.index);
          } else if (delta < 0 && parseInt(this.main.offsetTop) < 0) {
            // 向上滚动
            this.index--;
            this.toPage(this.index);
          }
          // 本次翻页结束，记录结束时间，用于下次判断
          this.endTime = new Date().getTime();
        }
      }
    },
    // 翻页
    toPage(index) {
      console.log("toPage==" + index);
      if (index <= 5 && index > 0) {
        setTimeout(() => {
          this.$parent.hideHeader = index == 1;
          this.introduceshow = index != 1;
        }, 200);
        if (index != this.curIndex) {
          let delta = index - this.curIndex;
          this.nowTop = this.nowTop - delta * this.screenHeight;
          this.curIndex = index;
        }
        if (index == 5) {
          this.$refs.swiperBox.ScrollImgLeft();
          // this.$refs.swiperBox.reset();
        }
      }
    },
    getCompanyInfo(){
      this.$http.get("hdbs/api/companyinfo/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.companyInfo = response.data.page.list[1];
          }
        }.bind(this)
      );
    },
    getInfo() {
      this.$http.get("hdbs/api/publicity/honor/list").then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            var list = response.data.page.list;
            // this.zzry = list.concat(response.data.page.list);
            for (var i = 0; i < 10; i++) {
              list.concat(list);
            }
            this.zzry = list;
            this.bannertext =
              this.language == "zh" ? this.zzry[0].title : this.zzry[0].titleEn;
          }
          // this.initSwiper();
        }.bind(this)
      );
    },
    enter(i) {
      this.eleindex = i;
    },
    out(i) {
      this.imgindex = -1;
    },
    changetext(i) {
      this.bannertext =
        this.language == "zh" ? this.zzry[i].title : this.zzry[i].titleEn;
    },
    getInfoMenu() {
      this.$http.get("/hdbs/api/product/type/tree", {}).then(
        function (response) {
          var status = response.data.code;
          if (status === 0) {
            this.footmenu = response.data.data;
            this.footmenu.map((r) => {
              r.level = 1;
              if (!r.children && r.num == 0) {
                r.disabled = true;
                return false;
              }
              if (r.children) {
                r.children.map((c) => {
                  c.level = 2;
                  if (c.num == 0) {
                    c.disabled = true;
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.disabled = true;
                      });
                    }
                  } else {
                    if (c.children) {
                      c.children.map((a) => {
                        a.level = 3;
                        a.type1 = r.value;
                        if (a.num == 0) {
                          a.disabled = true;
                        }
                      });
                    }
                  }
                });
              }
            });
            console.log(this.footmenu);
          }
        }.bind(this)
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.el-carousel__item h3 {
  color: red;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  // background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  // background-color: #d3dce6;
}

html, body {
  height: 100%;
}

body, ul, li, a, p, div {
  /* 慎删 */
  padding: 0px;
  margin: 0px;
}

#wrap {
  overflow: hidden;
  width: 100%;
}

#main {
  position: relative;
  transition: top 1.5s;
}

.page {
  /* 谨删 */
  width: 100%;
  margin: 0;
  z-index: 1;
  background: #ffffffe6;
}

#pageUl {
  position: fixed;
  left: 11vw;
  top: 8rem;
}

.showUl {
  opacity: 1;
  visibility: visible;
  transition: all 3s;
}

.hideUl {
  visibility: hidden;
  opacity: 0;
  transition: all 0.5s;
}

.introduce {
  .nav-item {
    cursor: pointer;
    padding: 10px 0;
    color: #727171;
    font-family: Regular;
    font-size: 1.7rem;
  }

  .nav-item.active {
    font-family: Demibold;
    color: #024580;

    .jiantou-right {
      width: 5px;
      margin-left: 12px;
    }
  }
}

#page1 {
  background: #ffffff00;
  position: relative;
  margin-top: calc(-65px - 6vh);

  .bannerimg {
    height: 100%;
    width: 100%;
    object-fit: cover;
    visibility: hidden;
  }

  .slide {
    position: absolute;
    top: 16rem;
    width: 100%;
    text-align: center;
    font-size: 1.7rem;
    color: #fff;

    img {
      width: 2rem;
    }
  }

  .slide-bottom {
    position: absolute;
    width: 100%;
    bottom: 30px;
    text-align: center;

    img {
      width: 300px;
    }
  }
}

.mainbox {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding-top: 5rem;
  justify-content: center;
  height: 100%;
}

#page2 {
  .el-row-top {
    // height: 50vh;
    margin-top: 2rem;
  }

  .bottom-card {
    width: 100%;
    margin-right: 10.5vw !important;

    .item {
      box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
      padding: 2vw;
      border-radius: 6px;
      display: flex;
      background: #fff;
      cursor: pointer;
      height:100%;

      img {
        width: 10rem;
        padding: 10px;
      }

      .bottom {
        padding-left: 2vw;
        font-size: 2.1rem;
        color: #727171;
        width: fit-content;

        .bigtitle {
          font-size: 2.7rem;
          font-family: Demibold;
          color: #024580;
          margin-bottom: 10px;
        }
      }
    }
  }

  .CompanyPhoto {
    border-radius: 6px;
    height: 55rem;
  }

  .aboutbox {
    .title {
      .bigtitle {
        font-family: Demibold;
        font-size: 2.7rem;
        color: #024580;
        margin-bottom: 10px;
      }

      .smalltitle {
        margin-top: 2rem;
        font-size: 1.7rem;
        color: #727171;
        // line-height: 2;
      }
    }

    .icontext {
      display: flex;
      margin-top: 40px;
      width: 100%;

      .item {
        flex: 1;

        .top {
          font-size: 20px;
          color: #024580;
          font-family: Demibold;

          img {
            width: 25px;
            margin-right: 10px;
          }
        }

        .bottom {
          margin-top: 20px;
          color: #727171;
          font-size: 12px;
        }
      }
    }
  }
}

.line-height-zh {
  line-height: 2 !important;
}

.line-height-en {
  line-height: 1.5 !important;
}

.biaoti {
  font-size: 2.7rem;
  font-family: Demibold;
  width: 100%;
  color: #024580;
  margin-bottom: 6vh;
  padding-bottom: 1vh;
  border-bottom: 1px solid var(--mainGary);
}

#page3 {
  .application {
    margin-right: 10.5vw;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    color: #024580;
    width: 100%;

    .or-container {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      height: 30rem;
    }

    .or-container:before {
      background-color: rgba(0, 0, 0, 0.4);
    }

    .box {
      background: #fff;
      flex: 1;
      overflow: hidden;
      transition: 0.5s;
      box-shadow: 0 20px 30px rgba(0, 0, 0, 0.1);
      //line-height: 0;
      height: 100%;
      border-radius: 6px;
      margin: 0 20px;
      position: relative;
      text-align: center;
    }

    .box:first-child {
      margin: 0 2rem 0 0;
    }

    .box:last-child {
      margin: 0 0 0 2rem;
    }

    .box > img {
      margin: 3rem;
      //padding: 3rem;
      -o-object-fit: cover;
      object-fit: cover;
      transition: 0.5s;
      width: 6rem;
    }

    .box > span {
      font-size: 3.8rem;
      display: block;
      text-align: center;
      height: 10rem;
      line-height: 2.6;
    }

    .eleactive {
      flex: 1;
      height: 40rem;
    }

    .eleactive > img {
      //padding: 3rem;
      object-fit: fill;
    }

    .eleactive .account {
      opacity: 1;
      transition: all 0.3s;
    }

    .top {
      margin-top: 1rem;
      font-size: 2.4rem;
      font-family: Demibold;
    }

    .bottom {
      font-size: 2rem;
      font-family: Regular;
      margin-top: 4rem;
    }

    .account {
      transition: all 0.3s;
      opacity: 0;
      position: absolute;
      bottom: 2rem;
      font-size: 1.7rem;
      font-family: Regular;
      line-height: 1.5;
      padding: 0 1rem;
      width: 100%;
    }
  }
}

#page4 {
  .mainbox {
    justify-content: flex-start;

    .huanjing {
      margin-right: 10.5vw;
      width: calc(100% - 10.5vw);
      margin-left: 21vw;
    }
  }
  .rongyu {
    margin-right: 10.5vw;
    flex-wrap: wrap;
    display: flex;
    align-items: center;
    color: #024580;
    //width: 100%;
    width:calc(100% - 10.5vw);

    .bannertext {
      text-align: center;
      font-family: Demibold;
      font-size: 2rem;
    }

    .el-carousel__container img {
      // width: 80%;
      object-fit: contain;
      // margin-left: 10%;
    }
  }
}

.dbanner {
  /deep/ .el-carousel__mask {
    background: #ffffff00;
  }

  position: relative;

  .bannerright {
    width: 8rem;
    position: absolute;
    cursor: pointer;
    bottom: calc(50% - 38px);
    z-index: 99;
    right: 0;
    padding: 5rem 3rem;
    border-radius: 6px;
  }

  .bannerleft {
    width: 8rem;
    position: absolute;
    cursor: pointer;
    bottom: calc(50% - 38px);
    z-index: 99;
    left: 0;
    padding: 5rem 3rem;
    border-radius: 6px;
  }

  .bannerleft:hover, .bannerright:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}

.margin-left {
  margin-left: 21vw;
}

#page5 {
  .mainbox {
    justify-content: flex-start;

    .huanjing {
      margin-right: 10.5vw;
      width: calc(100% - 10.5vw);
      margin-left: 21vw;
    }
  }
}

#page4 .rongyu {
  margin-left: 21vw;
}

#page3 .application {
  margin-left: 21vw;
}

.wrap_div {
  background-image: url('../../../static/img/Background.jpg');
  background-repeat: round;
}

.main_div {
}

.foot-div {
  bottom: 0;
  position: absolute;
  width: 100%;
}

.realData {
  //height: 100vh;
}


@media screen and (max-width: 1200px) {
  .mainbox {
    margin: 0 1rem;
    padding-top: 1rem;
  }

  #pageUl {
    display: none;
  }

  .container {
    max-width: revert;
  }

  #page3 .application {
    margin: 0;
  }

  #page3 .application .or-container {
    flex-direction: column;
    height: 85vh;
  }

  #page3 .application .box>img {
    margin:2rem 0 0;
    width:4rem;
  }

  #page3 .application .account {
    bottom: 0;
    width: 100%;
  }

  #page3 .application .box {
    margin: 20px 20px 0 20px;
  }

  #page3 .application .box:first-child {
    margin: 20px 20px 0 20px;
  }

  #page3 .application .box:last-child {
    margin: 20px 20px 0 20px;
  }
  #page3 .application .bottom{
    margin-top:0;
  }
  #page3 .application .top{
    margin-top:1rem;
  }

  #page2 .bottom-card {
    margin-right: 0 !important;
    display: none;
  }

  #page2 .bottom-card .item {
    margin-top: 2rem;
  }

  #page4 .rongyu {
    margin-right: 0;
    margin-left: 0;
  }

#page4 .mainbox .huanjing{
  margin-right:0;
  margin-left:0;
  width:100%;
}
  #page2 .CompanyPhoto {
    height: 20rem;
    object-fit: cover;
    width: 100%;
  }

  #page2 .bottom-card .item img {
    width: 8rem;
  }

  #page2 .bottom-card .item .bottom {
    font-size: 1.7rem;
  }

  #page2 .bottom-card .item .bottom .bigtitle {
    font-size: 2.1rem;
  }

  #page2 .aboutbox .title .smalltitle {
    margin-top: 0;
    line-height: 1.5;
  }

  .dbanner .bannerleft {
    width: 1.5rem;
    bottom: calc(50%);
    padding: 0;
  }

  .dbanner .bannerright {
    width: 1.5rem;
    bottom: calc(50%);
    padding: 0;
  }

  .biaoti {
    margin-bottom: 1rem;
  }

  #page5 .mainbox .huanjing {
    margin-right: 0;
    margin-left: 0;
    width: 100%;
  }

  .foot-div {
    margin-left: -1rem;
  }
}

@media screen and (max-height: 740px) {
  #page2 .bottom-card {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs/AboutUs.vue